import { put } from '@redux-saga/core/effects';
import isEmpty from 'lodash/isEmpty';
import { select } from 'typed-redux-saga';

import { xcriticalFormError, xcriticalFormInit } from '@xcritical/forms';

import { getUser } from '@crm-framework/auth';
import { handleServerError } from '@crm-framework/utils';

import {
  dictionariesActions,
  loadAndSaveDictionariesByName,
  loadAndSaveDictionariesByType,
  mapBUbyEnvironments,
} from '@crm-package/dictionaries';

import { LEAD_FORM_NAME, LeadDetailsDictionaries } from './consts';
import { leadFormSelector } from './selectors';

export function* loadDictionary() {
  yield* loadAndSaveDictionariesByName(
    [
      LeadDetailsDictionaries.timeZone,
      LeadDetailsDictionaries.countryStates,
      LeadDetailsDictionaries.closerManager,
      LeadDetailsDictionaries.salesManager,
      LeadDetailsDictionaries.conversionAgent,
      LeadDetailsDictionaries.language,
      LeadDetailsDictionaries.retentionManager,
      LeadDetailsDictionaries.tradingStatus,
      LeadDetailsDictionaries.vipManager,
      LeadDetailsDictionaries.leadTag,
    ],
    {},
    [
      LeadDetailsDictionaries.timeZone,
      LeadDetailsDictionaries.countryStates,
      LeadDetailsDictionaries.closerManager,
      LeadDetailsDictionaries.salesManager,
      LeadDetailsDictionaries.conversionAgent,
      LeadDetailsDictionaries.language,
      LeadDetailsDictionaries.retentionManager,
      LeadDetailsDictionaries.tradingStatus,
      LeadDetailsDictionaries.vipManager,
      LeadDetailsDictionaries.leadTag,
    ]
  );

  yield* loadAndSaveDictionariesByType([
    LeadDetailsDictionaries.salesStatus,
    LeadDetailsDictionaries.salesStatusRejectReason,
    LeadDetailsDictionaries.eligibilityRejectReason,
    LeadDetailsDictionaries.country,
  ]);
}

export function* handleLeadServerError(error) {
  console.error(error);
  const serverError = JSON.parse(error.text);
  const serverValidationErrors = serverError?.ValidationErrors;

  if (serverValidationErrors) {
    const errors = serverValidationErrors.reduce(
      (acc, { Description, ElementName }) => {
        acc[ElementName] = Description;

        return acc;
      },
      {}
    );
    yield put(xcriticalFormError(LEAD_FORM_NAME, errors));
  } else {
    handleServerError(error);
    const { source } = yield* select(leadFormSelector);
    yield put(xcriticalFormInit(LEAD_FORM_NAME, source));
  }
}

export function* loadBusinessUnitDictionaryByRights(buRight: string) {
  const { businessUnit, environment } = yield* loadAndSaveDictionariesByName(
    [LeadDetailsDictionaries.businessUnit, LeadDetailsDictionaries.environment],
    {},
    [LeadDetailsDictionaries.businessUnit, LeadDetailsDictionaries.environment]
  );

  const { businessUnitRights } = (yield* select(getUser))!;

  const availableBUByRights =
    !isEmpty(businessUnitRights[buRight]) &&
    isEmpty(businessUnitRights.all || [])
      ? businessUnit.filter((item) =>
          businessUnitRights[buRight]?.includes(item.id)
        )
      : businessUnit;

  const businessUnitsByEnvironment = mapBUbyEnvironments(
    environment,
    availableBUByRights
  );

  yield put(
    dictionariesActions.addOrUpdate({
      businessUnitsByEnvironment,
    })
  );
}
